import { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import Modal from './Modal';
import InlineLoader from '../Loader/InlineLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faReceipt } from '@fortawesome/free-solid-svg-icons';
import { formatPrice } from '../../utils/FormatPrice';
import { formatRelativeDate, formatFullDate } from '../../utils/FormatDate';
import { API_BASE_URL } from '../../api';

export default function PatientDebtModal({ show, onClose, patientId, totalDue }) {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!show || !patientId) return;
        setLoading(true);
        axios.get(`${API_BASE_URL}/api/v1/getOrders`, {
            withCredentials: true,
            params: { page: 0, size: 1000, sortField: 'createdAt', sortDirection: 'desc', patientId },
        })
            .then(({ data }) => {
                const unpaid = (data.content || [])
                    .filter((o) => o.status !== 'CANCELED')
                    .map((o) => ({ ...o, remaining: (o.total ?? 0) - (o.paiedAmount ?? 0) }))
                    .filter((o) => o.remaining > 0.001);
                setOrders(unpaid);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [show, patientId]);

    return (
        <Modal
            title="Origine de la dette"
            show={show}
            onClose={onClose}
            icon={faCircleInfo}
            iconBg="#fef2f2"
            iconColor="#dc2626"
        >
            <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>
                Le solde restant dû provient des ventes ci-dessous, dont le montant payé est inférieur au total.
            </p>

            {loading ? (
                <InlineLoader small />
            ) : orders.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 24, color: '#9ca3af', fontSize: 13 }}>
                    Aucune vente impayée trouvée.
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {orders.map((o) => (
                        <div
                            key={o.id}
                            style={{
                                display: 'flex', alignItems: 'center', gap: 12,
                                padding: '10px 12px', border: '1px solid #f0f1f3', borderRadius: 10,
                            }}
                        >
                            <span style={{
                                width: 32, height: 32, borderRadius: 8, flexShrink: 0,
                                background: '#fef2f2', color: '#dc2626',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13,
                            }}>
                                <FontAwesomeIcon icon={faReceipt} />
                            </span>

                            <div style={{ flex: 1, minWidth: 0 }}>
                                <NavLink to={`/order/${o.id}`} style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#111827', textDecoration: 'none' }}>
                                    {o.reference}
                                </NavLink>
                                <span
                                    style={{ fontSize: 11, color: '#9ca3af' }}
                                    data-tooltip-id="tooltip"
                                    data-tooltip-content={formatFullDate(o.createdAt)}
                                >
                                    {formatRelativeDate(o.createdAt)}
                                </span>
                            </div>

                            <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                <div style={{ fontSize: 12, color: '#9ca3af' }}>
                                    {formatPrice(o.paiedAmount)} / {formatPrice(o.total)}
                                </div>
                                <div style={{ fontSize: 13, fontWeight: 700, color: '#dc2626' }}>
                                    -{formatPrice(o.remaining)}
                                </div>
                            </div>
                        </div>
                    ))}

                    <div style={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        marginTop: 6, paddingTop: 12, borderTop: '1px solid #f0f1f3',
                        fontSize: 13, fontWeight: 700, color: '#111827',
                    }}>
                        <span>Total dû</span>
                        <span style={{ color: '#dc2626' }}>{formatPrice(totalDue)}</span>
                    </div>
                </div>
            )}
        </Modal>
    );
}
